import React from 'react';
import { Text } from '../../../../../../ui/atoms/Text/Text';
import { SUPPORT_NOTICE } from '../../../../constants/support';
import './SupportNoticeStyles.scss';
const BASE_CLASS = 'ai-support-notice';
const NOTICE_ICONS = {
    [SUPPORT_NOTICE.CHAT_STARTED]: 'fa-light fa-comments',
    [SUPPORT_NOTICE.EMAIL_SENT]: 'fa-light fa-envelope-circle-check',
    [SUPPORT_NOTICE.CHAT_ENDED]: 'fa-light fa-comment-check'
};
/**
 * What the customer did with support, as a small centred muted line in the thread ("You started a
 * chat with InspectPoint Support.", "You emailed ...", "Chat with InspectPoint Support ended.").
 * It is a record, not a message: no bubble, no author, no action bar, nothing to click.
 */
export function SupportNotice({ kind, text }) {
    return (React.createElement("div", { className: `${BASE_CLASS} ${BASE_CLASS}--${kind}`, "data-testid": "support-notice" },
        React.createElement("i", { className: NOTICE_ICONS[kind], "aria-hidden": "true" }),
        React.createElement(Text, { variant: "xx-small" }, text)));
}
